<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        List of Holidays
    </div>
    <div class="card-body p-1" style="overflow: auto;">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col" style="display: none;">Client Group Name</th>
                    <th scope="col" style="display: none;">Emp Code</th>
                    <th scope="col" style="display: none;">Full Name</th>
                    <th scope="col" style="display: none;">Site Name</th>
                    <th scope="col" style="display: none;">State Name</th>
                    <th scope="col" style="display: none;">Year</th>
                    <th scope="col">Holiday Name</th>
                    <th scope="col">Date</th>
                    <th scope="col">Type of Holiday </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let holiday of HolidayListsOnID; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td style="display: none;">{{ holiday['ClientGroupName'] }}</td>
                    <td style="display: none;">{{ holiday['EMPCode'] }}</td>
                    <td style="display: none;">{{ holiday['FullName'] }}</td>
                    <td style="display: none;">{{ holiday['SiteName'] }}</td>
                    <td style="display: none;">{{ holiday['StateName'] }}</td>
                    <td style="display: none;">{{ holiday['Year'] }}</td>
                    <td>{{ holiday['HolidayName'] }}</td>
                    <td>{{ holiday['Date']}}</td>
                    <td>{{ holiday['TypesOfLeave']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>